// extracted by mini-css-extract-plugin
module.exports =  {"title":"title_Ah3CtOI3"};